type LabelProps = {
    children?  : string
    padding?   : string
    size?      : string
    fontWeight? : string
    color? : string
    textAlign? : CanvasTextAlign 
}

const Label: React.FC<LabelProps> = ({
    children="", 
    padding="0px 20px", 
    size="large", 
    fontWeight="500", 
    color="#565656",
    textAlign = "left"
}) => {
    return <div style={{
        textAlign: textAlign,
        padding: padding,
        color:color, 
        fontSize:size, 
        fontWeight:fontWeight,
        textWrap:"nowrap"}}>
        {children}
    </div>
}

export default Label